import React from "react"
import ReactDOM from "react-dom";
import _ from "underscore"
import { isNotEmpty, isEmpty } from "../../../framework/utils";
import { optional, parseBoolean, uuid } from "../../../utils/lang";
import { isMobile } from "../../utils/mobile";
import { EntitiesSelectContainer } from "../containers";
import { MaterialIcon } from "../materialIcon";

export class MobileInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            parentValue: this.props.value,
        }
    }

    componentDidMount() {
        this.syncValue();
    }

    componentDidUpdate() {
        this.syncValue();
    }

    syncValue() {
        if (this.props.value !== this.state.parentValue) {
            this.setState({
                value: this.props.value,
                parentValue: this.props.value,
            })
        }
    }

    onChange(e) {
        const value = e.target.value;
        this.setState({value: value});
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            this.props.onChange(e);
        }
    }

    onIconClick(e) {
        if (this.props.onIconClick && _.isFunction(this.props.onIconClick)) {
            this.props.onIconClick(e)
        }
    }

    render() {
        const label = this.props.label,
            disabled = parseBoolean(optional(this.props.disabled, false)),
            icon = disabled ? "lock" : this.props.icon,
            clickableIcon = this.props.icon && this.props.onIconClick && _.isFunction(this.props.onIconClick),
            useTextarea = parseBoolean(optional(this.props.useTextarea, false)),
            outlined = parseBoolean(optional(this.props.outlined, false)),
            inputProps = _.extend(
                    _.omit(
                        this.props,
                        "className",
                        "label",
                        "icon",
                        "onIconClick",
                        "useTextarea",
                        "outlined",
                        "onChange"
                    ),
                    {
                        value: this.state.value,
                        onChange: this.onChange.bind(this)
                    }
                ),
            InputComponent = React.createElement(
                    useTextarea ? "textarea" : "input",
                    inputProps
                );
        let className = "form-group";

        if (outlined) {
            className += " form-group--outlined";
        }

        if (isNotEmpty(this.props.className)) {
            className += " " + this.props.className;
        }

        return (
            <div
                className={className}
            >
                {label && <label>
                    {label}
                </label>}
                <div
                    className="input-group"
                >
                    {InputComponent}
                    {icon && (
                        <div className="input-group-append">
                            <span className={"input-group-text" + (clickableIcon ? " input-group-text--clickable" : "")}>
                                <MaterialIcon
                                    icon={icon}
                                    onClick={this.onIconClick.bind(this)}
                                />
                            </span>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export class MobilePasswordInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        }
    }

    toggleVisibility() {
        this.setState({
            visible: !this.state.visible,
        })
    }

    render() {
        return(
            <MobileInput
                {..._.omit(this.props, "type", "icon")}
                type={(this.state.visible ? "text" : "password")}
                icon={this.state.visible ? "visibility_off" : "visibility"}
                onIconClick={this.toggleVisibility.bind(this)}
            />
        )
    }
}

export class MobileDateInput extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    componentDidMount() {
        const input = ReactDOM.findDOMNode(this.inputRef.current);
        $(input).find("input").flatpickr(
            {
                appendTo: input,
                onChange: this.onChange.bind(this),
                dateFormat: "d/m/Y",
            }
        );
    }

    onChange(e) {
        ReactDOM.findDOMNode(this.inputRef.current).querySelector("input").blur();
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            this.props.onChange(e);
        }
    }

    render() {
        let className = "form-group--date-time";

        if (this.props.className) {
            className += " " + this.props.className;
        }

        const _props = _.extend(
            {},
            this.props,
            {
                className: className,
                type: "text",
            }
        )

        if (!isMobile()) {
            _props.icon = "calendar_today"
        }

        return (<MobileInput
                ref={this.inputRef}
                {..._props}
            />)
    }
}
export class MobileTextArea extends React.Component {
    render() {
        return(
            <MobileInput
                {...this.props}
                useTextarea={true}
                rows={12}
            />
        )
    }
}

export class MobileSelect extends React.Component {
    constructor(props) {
        super(props);
        this.uuid = uuid();
        this.selectRef = React.createRef();
        this.state = {
            value: this.props.value,
            parentValue: this.props.value,
        }
        this.onDatasourceChange = () => this.forceUpdate();
    }

    componentDidMount() {
        this.props.datasource.on("change",this.onDatasourceChange);
        $(this.selectRef.current).select2(
            {
                width: "100%",
                dropdownParent: $(ReactDOM.findDOMNode(this)),
            }
        ).on("change", this.onChange.bind(this));
        this.syncValue();
    }

    componentDidUpdate() {
        this.syncValue();
    }

    componentWillUnmount() {
        this.props.datasource.off("change",this.onDatasourceChange);
    }

    syncValue() {
        if (this.props.value !== this.state.parentValue) {
            this.setState({
                value: this.props.value,
                parentValue: this.props.value,
            }, this.sanitizeValue.bind(this))
        } else {
            this.sanitizeValue();
        }
    }

    sanitizeValue() {
        const options = this.getOptions(),
            value = this.getValue(),
            allowNull = this.isEmpyAllowed();

        if (!allowNull && isNotEmpty(options) && isEmpty(value)) {
            const defaultValue = _.first(options).value;
            if (isNotEmpty(defaultValue)) {
                const $select = $(this.selectRef.current);
                $select.val(defaultValue);
                $select.trigger("change");
            }
        }
    }

    isEmpyAllowed() {
        return parseBoolean(this.props.allowNull ?? false);
    }

    getOptions() {
        const rows = this.props.datasource?.data?.rows ?? [];
        let values = [];

        if (this.isEmpyAllowed()) {
            values.push({
                value: "",
                label: this.props.nullText ?? M("noSelection"),
            });
        }

        return _.union(values, rows);
    }

    getValue() {
        return this.state.value;
    }

    onChange(e) {
        const value = e.target.value;
        this.setState({value: value});
        if (this.props.onChange && _.isFunction(this.props.onChange)) {
            this.props.onChange(e);
        }
    }

    getLabel(value) {
        const options = this.getOptions();
        return _.findWhere(options, {value: value})?.label ?? ""
    }

    render() {
        const value = this.getValue(),
            label = this.props.label,
            outlined = this.props.outlined ?? false,
            options = this.getOptions();
        let className = "form-group form-group--select";

        if (outlined) {
            className += " form-group--outlined";
        }

        if (isNotEmpty(this.props.className)) {
            className += " " + this.props.className;
        }

        return (
            <div
                className={className}
            >
                {label && <label>
                    {label}
                </label>}
                <div
                    className="input-group"
                >
                    <select
                        ref={this.selectRef}
                        name={this.props.name}
                        value={value}
                        multiple={false}
                        onChange={this.onChange.bind(this)}
                    >
                        {_.map(options, (option, index) => {
                            const {label, value} = option;
                            return (<option
                                key={"mobile-select-" + this.uuid + "-option-" + index}
                                value={value}
                                name={value}
                            >
                                {label}
                            </option>)
                        })}
                    </select>
                </div>
            </div>
        )
    }
}

export class MobileEntitiesSelect extends EntitiesSelectContainer {
    render() {
        return <MobileSelect
            {...this.props}
            datasource={this.datasource}
        />
    }
}

export function changeOnBlur(Component, valueMapper) {
    return class WrappedInput extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                value: props.value,
                parentValue: props.value,
            }
        }

        componentDidUpdate() {
            const oldValue = this.state.parentValue?.toString() ?? "",
                newValue = this.props.value?.toString() ?? "";

            if (oldValue !== newValue) {
                this.setState({
                    value: this.props.value,
                    parentValue: this.props.value,
                })
            }
        }

        onChange(e) {
            const value = valueMapper && _.isFunction(valueMapper)
                ? value = valueMapper(e)
                : optional(() => e.target.value);

            this.setState({value: value});
        }

        onBlur(e) {
            if (this.props.onChange && _.isFunction(this.props.onChange)) {
                this.props.onChange(e);
            }

            if (this.props.onBlur && _.isFunction(this.props.onBlur)) {
                this.props.onBlur(e);
            }
        }

        render() {
            const _props = _.omit(this.props, "onChange", "onBlur", "value"),
                value = this.state.value;

            return (<Component
                    {..._props}
                    value={value}
                    onChange={this.onChange.bind(this)}
                    onBlur={this.onBlur.bind(this)}
                />)
        }
    }
}